/* =============================================================================
   hd-signup.js —— Creator 注册/身份弹窗（onboarding）  2026-10-14 外置
   -----------------------------------------------------------------------------
   来源：原在 sections/design-canvas.liquid 内（HTML 26 行 + JS ~219 行）。
   为什么要外置：那段 HTML 只挂在设计台**一个页面** ⇒ 顶栏「Verify」以前只能跳过去。
     外置后由 layout/theme.liquid 渲染 HTML + 本文件驱动 ⇒ 任何页面都能原地弹出。

   兄弟文件：
     · HTML —— snippets/hd-signup.liquid（全站渲染一次，元素 id 固定）
     · 样式 —— assets/hd-signup.css（.hdco-*；.hdco-toast 例外，它留在设计台）

   与设计台的接线（三条，全部由设计台侧赋值，本文件只读）：
     · window.__hdSignupBoot()        —— 本文件 defer 加载完成后回调（设计台在此 bind + 进站自动弹）
     · window.__hdSignupOnSave(email) —— 收集完成 ⇒ 继续「保存设计」（原 _pfmSavePending 分支）
     · window.__hdSignupIsPending()   —— 供 Skip 判断「是否有未保存的设计要丢弃」

   🔴 唯一实现：与 /pages/my-designs 共用同一个 localStorage 键（hdCreatorProfile_v1）
      与同一个校验口（POST /designs/check）；提示块/验证码链路共用 snippets/hd-email-taken。
   ============================================================================= */
(function () {
  'use strict';

  var KEY = 'hdCreatorProfile_v1';
  var SKIP_MS = 30 * 60 * 1000;
  var RMSG = 'This designer name is reserved. Please choose another one.';
  /* 无自带 hdet 的页面（弹窗背后那颗 hdet 看不见）⇒ 占用提示落本弹窗自己的 #hdcoErr。 */
  var TMSG = 'This email is already linked to a different designer name. Please use another email.';
  var BRIDGE = 'https://bridge.highdeep.net';

  /* 状态：原在设计台顶层声明（那边 hdcoShow/hdcoBind 是顶层调用，怕 TDZ）；
     外置后本 IIFE 自持 —— 本文件所有调用都在赋值之后，不再需要「提前声明」那套。 */
  var checking = false, checkT = null, lastChecked = '', reserved = false;
  /* 提示通道：设计台注入 hdcoToast（跟随设计板定位）；其余页面退到全站 HD.toast。 */
  var toastFn = null;

  function q(id) { return document.getElementById(id); }
  function bridge() { return BRIDGE; }
  function getParams() {
    try { return window.__pfmParams || new URLSearchParams(location.search); } catch (e) { return null; }
  }
  function toast(msg) {
    if (toastFn) { try { toastFn(msg); return; } catch (e) { } }
    try {
      if (window.HD && HD.toast) {
        /* HD.toast 是 textContent 口径 ⇒ 把原来喂给 innerHTML 的实体换成真字符 */
        HD.toast(String(msg).replace(/&mdash;/g, '\u2014').replace(/&rsquo;/g, '\u2019').replace(/&amp;/g, '&'));
      }
    } catch (e) { }
  }
  /* 按钮绑定：设计台有 window.__hdAct（翻译后重绑）；其余页面退到直接绑定。 */
  function bindAct(id, fn) {
    if (window.__hdAct && window.__hdAct.bind) { window.__hdAct.bind(id, fn); return; }
    var el = q(id); if (el) el.addEventListener('click', fn);
  }
  /* 「收集完档案后是否要继续保存设计」——设计台侧提供；其余页面恒 false。 */
  function isSavePending() {
    try { return !!(window.__hdSignupIsPending && window.__hdSignupIsPending()); } catch (e) { return false; }
  }
  function continueSave(email) {
    try { if (typeof window.__hdSignupOnSave === 'function') window.__hdSignupOnSave(email); } catch (e) { }
    /* 2026-10-29：注册 / 取回完成后广播 hd:signup-done —— 让收藏等挂起方续接。
       continueSave 是「正常注册(_hdcoFinish)」与「取回成功(hdcoAfterVerified)」两条路的共同收尾点。 */
    try {
      document.dispatchEvent(new CustomEvent('hd:signup-done', { detail: { email: String(email || '') } }));
    } catch (e) { }
  }

  /* ------------------------------------------------------------------ 档案存取 */
  function hdcoLoad() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || null; } catch (e) { return null; }
  }
  function hdcoSaveObj(o) {
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { }
    /* 2026-10-14: 顶栏身份区（assets/hd-nav-user.js）读的是同一份档案 ⇒ 写完立刻刷新它，
       否则填完昵称/邮箱后，站头那块仍停在「Verify」直到刷新页面。 */
    try { if (window.__hdNavUserRefresh) window.__hdNavUserRefresh(); } catch (e) { }
  }

  /* ------------------------------------------------------------------ 显隐 */
  function hdcoShow(force) {
    var wrap = q('hdcoWrap'); if (!wrap) return;
    // Buyer session (previewing an existing creator/official work) → never ask.
    var P = getParams();
    if (P && P.get && (P.get('creator_work_id') || P.get('design_url'))) return;
    /* 强制弹窗的两个来源：① 顶栏「Verify」按钮传 force=true ② 老链接 ?signup=1（保留，零回归） */
    var _force = !!force || !!(P && P.get && P.get('signup'));
    var prof = hdcoLoad();
    if (!_force && prof && prof.email && prof.nick) return; // 2026-10-06: 改为【邮箱+昵称都存过】才永久不再问 ——
                                   //   否则「有邮箱、无昵称」的访客永远拿不到昵称（My Works 门槛会把他锁在门外）。
    if (!_force && prof && prof.skip) {       // 已 Skip → 30 分钟内不弹，过期自动再提醒
      /* 2026-09-13: **只按 ts 算，不再读 skipUntil** —— 老数据里的 skipUntil 是「30 天」时期写死的
         （值 = 当时点击 + 30 天），继续优先读它会让这批用户仍被拦满 30 天，只改时长常量救不回来。 */
      var until = (prof.ts || 0) + SKIP_MS;
      if (Date.now() < until) return;
    }
    /* 2026-10-20：打开弹窗时**预填**已登录信息 —— 否则空表单让人不知道该填什么
       （实测：My Page 弹窗全空，用户以为自己没登录）。只填空值，不覆盖用户正在输入的。 */
    try {
      var _p0 = hdcoLoad() || {};
      var _ne0 = q('hdcoName'), _ee0 = q('hdcoEmail');
      if (_ne0 && !String(_ne0.value || '').trim()) _ne0.value = String(_p0.nick || '');
      if (_ee0 && !String(_ee0.value || '').trim()) _ee0.value = String(_p0.email || '');
    } catch (e) { }
    wrap.style.display = 'flex';
    /* 2026-10-13 默认投稿：记录勾选框初始态 —— 只有用户**自己改动过**才算「明确取消」。 */
    try { var _lc = q('hdcoList'); if (_lc) { _lc._init = _lc.checked; } } catch (e) { }
    /* 每次打开都按当前输入重算 Save 可用性，并清掉上一次留下的占用/保留名提示 */
    reserved = false;
    if (window.HDET) HDET.reset();
    if (typeof hdcoSyncSaveBtn === 'function') hdcoSyncSaveBtn();
    /* 2026-10-06: 入场态默认（可 Skip）；点 Save 触发的必填态由设计台置 true（经 hdcoHint(true)） */
    if (typeof hdcoHint === 'function') hdcoHint(false);
  }
  function hdcoClose() {
    var w = q('hdcoWrap'); if (w) w.style.display = 'none';
    reserved = false;
    var er = q('hdcoErr'); if (er) { er.classList.remove('show'); er.textContent = ''; }
  }
  /* 2026-10-06: 弹窗底部文案两态（入场可 Skip / 点 Save 场景必填） */
  function hdcoHint(saving) {
    var h = document.querySelector('#hdcoWrap .hdco-hint');
    if (!h) return;
    /* 2026-10-14：口径改为「邮箱 = 全站账户」—— 旧文案写 only used to find your saved designs，
       与事实不符（邮箱还承载 works / favorites / orders / image library / palette / earnings）。
       两个分支都是【静态字面量】⇒ 用 innerHTML 安全（无用户输入拼入）。 */
    h.innerHTML = saving
      ? 'Your email and designer name are both required to save this design.'
      : 'Your email is your Highdeep Creative account &mdash; your designs, works, favorites, orders and image library all follow it to any device.<br>Skip and this design stays on this device only.';
  }
  /* 2026-10-06: 保存场景校验 —— 指出具体缺哪项并聚焦，不关窗 */
  function hdcoRequireFields() {
    var ne = q('hdcoName'), ee = q('hdcoEmail'), err = q('hdcoErr');
    var name = ne ? String(ne.value || '').trim() : '';
    var email = ee ? String(ee.value || '').trim() : '';
    var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var msg = (!name && !email) ? 'Enter your email and designer name to save this design.'
      : (!email) ? 'Enter your email to save this design.'
        : (!okMail) ? 'That email does not look right.'
          : 'Enter your designer name to save this design.';
    if (err) { err.textContent = msg; err.classList.add('show'); }
    if (!okMail && ee) ee.focus(); else if (!name && ne) ne.focus();
  }

  /* ===== 2026-10-11 邮箱被占用：Save 前置校验 + 自助邮箱验证码取回 =====
     ── 口径三条 ──
       ① Save 在「昵称非空 + 邮箱格式正确」之前保持禁用（本地第一道闸）；
       ② 两字段都合法后输入防抖 400ms 调 /designs/check；被占用 ⇒ 琥珀提示 + 两条出路：
          「Verify this email」（收 6 位码自证归属 ⇒ 邮箱归还给他）／「Contact us」；
       ③ 点 Save 时再查一次（防抖可能没跑完）；后端 /designs/claim 仍有 409 兜底。
     ⚠️ 检查失败（网络/后端异常）一律**放行**（fail-open）—— 闸门问题绝不连累正常保存。
     提示 UI 与发码/验码链路在 snippets/hd-email-taken（window.HDET）。 */
  function hdcoFieldsOk() {
    var ne = q('hdcoName'), ee = q('hdcoEmail');
    var name = ne ? String(ne.value || '').trim() : '';
    var email = ee ? String(ee.value || '').trim() : '';
    return !!name && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function hdcoTakenNow() { return !!(window.HDET && HDET.taken); }
  /* Save 按钮态：字段不全 / 邮箱被占用 / 正在检查 ⇒ 禁用（三态合一，单一真源）。 */
  function hdcoSyncSaveBtn() {
    var b = q('hdcoSave'); if (!b) return;
    var ok = hdcoFieldsOk(), tk = hdcoTakenNow(), rs = reserved;
    b.disabled = !ok || tk || rs || checking;
    b.title = rs ? 'This designer name is reserved'
      : tk ? 'This email is already in use \u2014 verify it or contact us'
        : !ok ? 'Enter your designer name and email first' : '';
  }
  /* POST /designs/check -> Promise<''|'email_taken'|'nickname_reserved'>（异常一律回 '' = 放行） */
  function hdcoCheckEmail(email, nick) {
    return fetch(bridge() + '/designs/check', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: String(email || ''), nickname: String(nick || '') })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok || !d || d.ok !== false) return '';
          return (d.reason === 'email_taken' || d.reason === 'nickname_reserved') ? d.reason : '';
        });
      })
      .catch(function () { return ''; });
  }
  /* 检查结果落 UI 的唯一入口：保留名 -> #hdcoErr 红字；邮箱被占 -> 共享琥珀块；'' -> 全清 */
  function hdcoApplyCheck(c) {
    var e = q('hdcoErr'), rs = (c === 'nickname_reserved'), tk = (c === 'email_taken');
    reserved = rs;
    if (rs) { if (ownHdet && window.HDET) HDET.reset(); if (e) { e.textContent = RMSG; e.classList.add('show'); } }
    else {
      if (e && (e.textContent === RMSG || e.textContent === TMSG)) { e.classList.remove('show'); e.textContent = ''; }
      /* 自带 hdet ⇒ 占用态交给共享琥珀块；否则落 #hdcoErr（弹窗背后那颗看不见）。 */
      if (ownHdet) { if (window.HDET) HDET.mark(tk); }
      else if (tk && e) { e.textContent = TMSG; e.classList.add('show'); }
    }
    hdcoSyncSaveBtn();
  }
  /* 输入防抖查占用：两字段都合法才发请求（否则一边打字一边弹提示）。 */
  function hdcoScheduleCheck() {
    var ne = q('hdcoName'), ee = q('hdcoEmail');
    var email = ee ? String(ee.value || '').trim() : '', nick = ne ? String(ne.value || '').trim() : '';
    if (checkT) { clearTimeout(checkT); checkT = null; }
    if (reserved) hdcoApplyCheck('');   /* 用户一改动就撤掉上一次的保留名提示 */
    if (hdcoTakenNow()) { if (window.HDET) HDET.reset(); }
    hdcoSyncSaveBtn();
    if (!hdcoFieldsOk()) { lastChecked = ''; return; }
    var sig = email + '|' + nick;
    if (sig === lastChecked) return;
    checkT = setTimeout(function () {
      checkT = null;
      hdcoCheckEmail(email, nick).then(function (c) {
        lastChecked = sig;
        hdcoApplyCheck(c);
      });
    }, 400);
  }
  /* 供共享 snippet 取当前输入（发码 / 验码要用） */
  function hdcoCreds() {
    var ne = q('hdcoName'), ee = q('hdcoEmail');
    return { email: ee ? String(ee.value || '').trim() : '', nickname: ne ? String(ne.value || '').trim() : '' };
  }
  /* 验证码通过（邮箱已归还）⇒ 收尾并继续保存（与正常 Save 同一路径，禁第二份实现）。 */
  function hdcoAfterVerified(email, nick) {
    var list = q('hdcoList');
    hdcoSaveObj({ nick: String(nick || ''), email: String(email || ''), list: (list && list.checked) ? 1 : 0, listTouched: (list && list._init !== undefined && list.checked !== list._init) ? 1 : 0, ts: Date.now() });
    hdcoClose();
    toast('Email verified &mdash; saving your design');
    /* 2026-11-03（严格 session）：取回成功先重登换 session，再保存设计（否则 claim 用旧 session 绑旧账号）。 */
    fetch(bridge() + '/auth/login', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: String(email || ''), nickname: String(nick || '') })
    }).then(function () { continueSave(email); })
      .catch(function () { continueSave(email); });
  }

  /* 2026-10-14（用户实测）：本弹窗**是否自带** hd-email-taken —— snippet 仅在 with_hdet != false 时
     给根节点写 data-hdet="1"。**只有自带时才接管 window.HDET**：本文件是全站 defer 加载，
     而有些页面（如 /pages/my-designs）自己 render 了一份**页面级** hd-email-taken；
     无条件接管会把 getCreds 指到弹窗内的空输入框 ⇒ 页面上那颗「Verify this email」点击后
     email 为空 ⇒ api.send 里 `if(!email) return Promise.reject('no_email')` 被外层 .catch 吞掉
     ⇒ **完全静默、连提示都没有**（本次用户报的「点了没反应」就是这个）。 */
  var ownHdet = false;
  function hdcoBind() {
    var w = q('hdcoWrap'); if (!w) return;
    ownHdet = !!w.getAttribute('data-hdet');
    if (ownHdet && window.HDET) {
      HDET.getCreds = hdcoCreds;
      HDET.onChange = function () { hdcoSyncSaveBtn(); };
      HDET.onVerified = hdcoAfterVerified;
    }
    function skip() {
      /* 2026-10-12: 强制态补「放弃」出口（原为完全不关窗 ⇒ 什么都没填时无路可走，只能填完或刷页）；
         保留 10-06 初衷「不静默丢设计」—— 必须先经过 confirm 明确确认。 */
      if (isSavePending()) { if (!confirm('Discard this unsaved design?')) { hdcoRequireFields(); return; } hdcoClose(); return; }
      /* 2026-09-13: 合并而非整体覆盖 —— 原实现 hdcoSaveObj({skip:1,...}) 会把已存的 nick/email
         一并清掉（老用户一点 Skip 就丢昵称，而昵称是 Drop 署名用的）。 */
      var _p = hdcoLoad() || {}; _p.skip = 1; _p.skipUntil = Date.now() + SKIP_MS; _p.ts = Date.now();
      hdcoSaveObj(_p); hdcoClose();
    }
    /* 收尾：写档案 + 关窗 + （若是点 Save 触发的收集）继续保存设计。
       抽出来给「占用检查通过」「检查失败放行」两条路共用（禁第二份实现）。 */
    function _hdcoFinish(name, email, list) {
      var er = q('hdcoErr'); if (er) er.classList.remove('show');
      hdcoSaveObj({ nick: name, email: email, list: list ? 1 : 0, listTouched: (list && list._init !== undefined && list.checked !== list._init) ? 1 : 0, ts: Date.now() });
      hdcoClose();
      /* 2026-11-03（严格 session）：换账号/注册必须先重新登录种新 session，再继续保存设计。
         否则 /designs/claim 用旧 session 的 email ⇒ 设计绑旧账号、下单归属错人。 */
      fetch(bridge() + '/auth/login', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: String(email || ''), nickname: String(name || '') })
      }).then(function () {
        /* 2026-10-14（邮箱唯一性）：把档案同步落进服务端 design_users ——
           否则服务端查无此人，同一邮箱能被反复换昵称（见 my-designs 的 registerThen）。
           fire-and-forget：不阻塞保存流程；失败静默（与后端 _emailTaken 的 fail-open 同口径）。 */
        try {
          fetch(bridge() + '/designers/register', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: String(email || ''), nickname: String(name || '') })
          }).catch(function () { });
        } catch (e) { }
        continueSave(email);
      }).catch(function () {
        continueSave(email);   /* login 失败兜底：仍继续（claim 会 401 显式失败，不静默绑错） */
      });
    }
    function save() {
      var ne = q('hdcoName'), ee = q('hdcoEmail'), le = q('hdcoList'), err = q('hdcoErr');
      if (!ne || !ee || !le) return;
      var name = String(ne.value || '').trim().slice(0, 40);
      var email = String(ee.value || '').trim().slice(0, 120);
      var list = le.checked;
      if (!name) { if (err) { err.textContent = 'Please enter your name so we can credit you.'; err.classList.add('show'); } return; }
      /* 2026-09-13: 邮箱改【必填】—— 它是「换设备找回设计」的唯一凭据（原为仅勾选分成时必填） */
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (err) { err.textContent = 'Enter your email so we can save your design (you can reopen it on any device).'; err.classList.add('show'); } return;
      }
      /* 2026-10-11：已知被占用 ⇒ 不写档案、不关窗，停在提示态 */
      if (reserved) { if (err) { err.textContent = RMSG; err.classList.add('show'); } return; }
      if (hdcoTakenNow()) {
        /* 自带 hdet ⇒ 走共享琥珀块；否则（本页的 hdet 属于别人、在弹窗背后看不到）落本弹窗红字。 */
        if (ownHdet) { if (err) err.classList.remove('show'); if (window.HDET) HDET.show('notice'); }
        else if (err) { err.textContent = TMSG; err.classList.add('show'); }
        return;
      }
      if (checking) return;                       /* 上一次检查还在跑 */
      /* 提交前再查一次（防抖可能没跑完 / 用户直接点了 Save）。异常一律放行。 */
      checking = true; hdcoSyncSaveBtn();
      hdcoCheckEmail(email, name).then(function (c) {
        checking = false;
        if (c) { hdcoApplyCheck(c); return; }
        if (window.HDET) HDET.reset();
        hdcoSyncSaveBtn();
        _hdcoFinish(name, email, list);
      }).catch(function () {
        checking = false; hdcoSyncSaveBtn();
        _hdcoFinish(name, email, list);
      });
    }

    bindAct('hdcoSkip', skip);
    bindAct('hdcoX', skip);
    bindAct('hdcoSave', save);
    /* 2026-10-11：两字段任一改动 ⇒ 立刻重算按钮态 + 防抖查占用（含清掉上一次提示） */
    var _ne = q('hdcoName'), _ee = q('hdcoEmail');
    if (_ne) _ne.addEventListener('input', hdcoScheduleCheck);
    if (_ee) _ee.addEventListener('input', hdcoScheduleCheck);
    hdcoSyncSaveBtn();
  }

  /* ------------------------------------------------------------------ 对外 API */
  window.__hdSignup = {
    KEY: KEY,
    show: hdcoShow,          /* show(true) = 强制弹（顶栏 Verify）；show() = 按档案/Skip 规则 */
    open: hdcoShow,          /* 别名，语义同上 */
    bind: hdcoBind,
    close: hdcoClose,
    load: hdcoLoad,
    saveObj: hdcoSaveObj,
    hint: hdcoHint,
    requireFields: hdcoRequireFields,
    fieldsOk: hdcoFieldsOk,
    takenNow: hdcoTakenNow,
    syncSaveBtn: hdcoSyncSaveBtn,
    checkEmail: hdcoCheckEmail,
    applyCheck: hdcoApplyCheck,
    scheduleCheck: hdcoScheduleCheck,
    creds: hdcoCreds,
    afterVerified: hdcoAfterVerified,
    setToast: function (fn) { toastFn = (typeof fn === 'function') ? fn : null; },
    /* 2026-10-14：把调用方手上的邮箱/昵称**预填**进弹窗（/pages/my-designs 的新用户注册走这里）。
       无条件覆盖 —— 调用方给的值就是用户刚填的，比弹窗里的旧值新。 */
    setPrefill: function (email, nick) {
      var ne = q('hdcoName'), ee = q('hdcoEmail');
      if (ne) { ne.value = String(nick || ''); }
      if (ee) { ee.value = String(email || ''); }
      hdcoSyncSaveBtn();
    }
  };

  /* defer 脚本：DOM 已解析完 ⇒ 弹窗元素一定在（layout 里 render 过）。
     ① 先无条件绑事件（非设计台页点 Verify 也要能用）；
     ② 再回调设计台侧的 __hdSignupBoot（由它决定 bind + 进站自动弹）。 */
  /* ---------------- 2026-10-20（用户定）：在线校验 —— 后台档案是唯一真源 ----------------
     前端 localStorage 可能是旧账号（换账号后没更新）⇒ 作品挂错人。
     规则：valid && verified ⇒ 放行；valid && !verified ⇒ 弹窗要求输码；invalid ⇒ 自动登出。
     ⚠️ 网络异常**不登出**（避免断网误踢）；localhost 调试同样不动。 */
  function hdcoVerifyOnline() {
    var prof = hdcoLoad();
    if (!prof || !String(prof.email || '').trim()) return;   /* 无缓存 = 新访客，不校验 */
    var email = String(prof.email).trim();
    var nick = String(prof.nick || '').trim();
    fetch(bridge() + '/designs/whoami?email=' + encodeURIComponent(email) +
          (nick ? ('&nickname=' + encodeURIComponent(nick)) : ''), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
      if (!d || typeof d.valid === 'undefined') return;      /* 异常响应 ⇒ 不动 */
      if (d.valid) return;                                   /* 档案核对通过 ⇒ 放行 */
      /* 2026-10-29：昵称对不上（可能只是点号/空格等格式差异）不清空 —— 作品认人按 email，
         清空反而导致顶栏头像消失、被迫重登。只有「账号不存在」才登出。 */
      if (d.reason === 'nickname_mismatch') return;
      /* 无效（账号不存在）⇒ 自动登出 */
      try { localStorage.removeItem(KEY); } catch (e) {}
        try { if (window.__hdNavUserRefresh) window.__hdNavUserRefresh(); } catch (e) {}
        try { hdcoShow(true); } catch (e) {}
        try { toast('Your designer session expired \u2014 please verify again'); } catch (e) {}
      })
      .catch(function () { /* 网络异常 ⇒ 不登出 */ });
  }

  /* 2026-11-03（严格 session）：静默登录 —— 有 localStorage 身份时自动调 /auth/login 种
     session cookie，老用户无感迁移。sessionStorage 节流（本会话只做一次，避免 rateLimit）。 */
  function hdcoSilentLogin() {
    try {
      var prof = hdcoLoad();
      if (!prof) return;
      var email = String(prof.email || '').trim();
      var nick = String(prof.nick || prof.nickname || '').trim();
      if (!email || !nick) return;
      if (sessionStorage.getItem('hdSilentLoginDone')) return;
      sessionStorage.setItem('hdSilentLoginDone', '1');
      fetch(bridge() + '/auth/login', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, nickname: nick })
      }).catch(function () {});
    } catch (e) {}
  }

  try { hdcoBind(); } catch (e) { }
  try { hdcoVerifyOnline(); } catch (e) { }
  try { hdcoSilentLogin(); } catch (e) { }
  try { if (typeof window.__hdSignupBoot === 'function') window.__hdSignupBoot(); } catch (e) { }
})();
